import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/",
)({
  loader({ params }) {
    throw redirect({
      to: "/orgs/$slug/athletes/$athleteId/questionnaires/$questionnaireId/submissions",
      params,
    });
  },
});
